import Svg, { Circle, Path } from "react-native-svg";
import { Text, TouchableOpacity, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";

import BottomSheetModal from "src/components/BottomSheetModal";
import ImageView from "../../../src/image";

import React, { useState } from "react";
import VText from "src/components/VText";
import { useLocalSearchParams } from "expo-router";
import { useRef } from "react";
import { useWindowDimensions } from "react-native";

export default React.forwardRef((props, ref) => {
    const _sizeGuideRef = useRef();
    const [mask, setMask] = useState("");
    const { height, width } = useWindowDimensions();

    const local = useLocalSearchParams();

    const gender = local?.gender ?? "female";

    React.useImperativeHandle(ref, () => ({ show, hide }), []);

    const show = (mask) => {
        setMask(mask);
        _sizeGuideRef?.current?.show();
    };

    const hide = () => {
        _sizeGuideRef?.current?.hide();
    };

    return (
        <BottomSheetModal
            START_PERC={1}
            MAX_HEIGHT_PERC={1}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
            ref={_sizeGuideRef}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={() => _sizeGuideRef?.current?.hide()}
            >
                <TouchableOpacity
                    style={{
                        width: wp(430),
                        minHeight: "auto",
                        backgroundColor: "#fff",
                        // paddingVertical: spV(19),
                        // paddingHorizontal: spH(25),
                        overflow: "hidden",
                        cursor: "auto",
                    }}
                    activeOpacity={1}
                >
                    <VText
                        style={{ fontSize: fp(20), fontWeight: "350", textAlign: "center", paddingVertical: spV(20) }}
                    >
                        Are you sure you want to delete this card?
                    </VText>

                    <View
                        style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            gap: wp(0),
                            borderTopWidth: 1,
                            borderColor: "#2124274D",
                        }}
                    >
                        <VText
                            style={{
                                fontSize: fp(20),
                                width: "50%",
                                paddingVertical: spV(20),
                                fontWeight: "350",
                                textAlign: "center",
                                color: "#CE1A1A",
                                borderRightWidth: 1,
                                borderColor: "#2124274D",
                                cursor: "pointer",
                            }}
                            onPress={() => _sizeGuideRef?.current?.hide()}
                        >
                            Cancel
                        </VText>
                        <VText
                            style={{
                                fontSize: fp(20),
                                width: "50%",
                                paddingVertical: spV(20),
                                fontWeight: "350",
                                textAlign: "center",
                                color: "#212427",
                                cursor: "pointer",
                            }}
                            onPress={() => props?.onPressDelete(mask)}
                        >
                            Yes, Delete
                        </VText>
                    </View>
                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});
